import request from '@/api/utils';

// eslint-disable-next-line import/prefer-default-export
export function getSantrallerMinuteGrup(formdata = {}, method = 'post') {
  const url = '/api/santraller/minuteGrup';
  return request.Api(url, formdata, method);
}
